import header from '../img/1111_logo.svg'
import footerLogo from '../img/footer_logo.png'
import footerSocial01 from '../img/facebook-icon.svg'
import footerSocial02 from '../img/line-icon.svg'
import footerSocial03 from '../img/twitter-icon.svg'
import footerToTop from '../img/goToTop.svg'
import jobCard from '../img/job-card-cover.png'
import jobCardIcon01 from '../img/job-card-icon01.png'
import jobCardIcon02 from '../img/job-card-icon02.png'
import articleSection from '../img/article-cover.png'
import archive_img from '../img/archive-ex-img.png'
import pgnb2 from '../img/pgnb-style2-arrow.svg'
import swiperImg from '../img/swiper-img.png'
import categoryImg from '../img/category-img.png'
import logo_ex from '../img/brand-ex.png'
import categoryItem01 from '../img/category-item01.png'
import categoryItem02 from '../img/category-item02.png'
import categoryItem03 from '../img/category-item03.png'
import categoryItem04 from '../img/category-item04.png'
import categoryItem05 from '../img/category-item05.png'
import categoryItem06 from '../img/category-item06.png'
import categoryItem07 from '../img/category-item07.png'
import categoryItem08 from '../img/category-item08.png'
import categoryItem09 from '../img/category-item09.png'
import categoryItem10 from '../img/category-item10.png'
import categoryItem11 from '../img/category-item11.png'
import ad from '../img/ad-ex.png'
import talentBanner from '../img/talent-banner.png'
import talentAd from '../img/talent-ad.png'
import companyBrand from '../img/company-logo.png'
import companySwiper01 from '../img/company-swiper01.png'
import companyStory01 from '../img/company-story-img01.png'
import downloadIcon from '../img/download-icon.svg'
import companyimg01 from '../img/company-target.png'
import companyimg02 from '../img/company-award01.png'
import companyimg03 from '../img/company-award02.png'
import companyimg04 from '../img/company-award03.png'
import singlepost_ex1 from '../img/single-post-ex1.png'
import singlepost_ex2 from '../img/single-post-ex2.png'
import sidebar_ex1 from '../img/sidebar-ex1.png'
import sidebar_ex2 from '../img/sidebar-ex2.png'
import sidebar_ex3 from '../img/sidebar-ex3.png'
import sidebar_ex4 from '../img/sidebar-ex4.png'
import sidebar_ex5 from '../img/sidebar-ex5.png'
import sidebar_ex6 from '../img/sidebar-ex6.png'
import btm_prev from '../img/btm-prev-post.png'
import btm_next from '../img/btm-next-post.png'
import post_cover_ex from '../img/post-cover-ex.png'
import award_1 from '../img/gold.svg'
import award_2 from '../img/silver.svg'
import award_3 from '../img/bronze.svg'
import brand_logo_category from '../img/brand-logo-category.png'
import input_file_svg from '../img/input-file.svg'
import loginIcon01 from '../img/login-user.svg'
import loginIcon02 from '../img/login-company.svg'
import loginBrand from '../img/login-brand.svg'
import lotteryUser from '../img/lottery-user.svg'
import closedkbtn from '../img/close-dialog-btn.svg'